var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    fill: "#C2EED9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 8H12C10.8954 8 10 8.89543 10 10V19C10 20.1046 10.8954 21 12 21H21C22.1046 21 23 20.1046 23 19V13.5C22.5 13 17.5 8.5 17 8ZM12 6C9.79086 6 8 7.79086 8 10V19C8 21.2091 9.79086 23 12 23H21C23.2091 23 25 21.2091 25 19V12.5L18 6H12Z",
    fill: "#40D9B5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 6V14H25",
    stroke: "#40D9B5",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.429f42523361ab921e9de93a74593d22.svg";
export { ForwardRef as ReactComponent };